import React, { useState, useEffect } from 'react';
import { css } from '@emotion/react';
import Image from 'gatsby-plugin-sanity-image'
import PortableText from '../components/portable-text';

export default function Tabs({tabs}) {
  const [active, setActive] = useState(0);

  return (
    <div
      css={css`
        padding-bottom: 9rem;
        border-bottom: 1px solid var(--black);
      `}
    >
      <div
        className="type--small-uppercase"
        css={css`
          display: flex;
          border-top: 1px solid var(--black);

          @media (max-width: 900px) {
            overflow-x: scroll;

            & > div {
              flex-basis: auto;
              padding: 1.9rem 1.9rem 1.5rem !important;

              &:last-of-type {
                flex-grow: 1;
              }
            }
          }

          & > div {
            padding: 1.9rem 1rem 1.5rem;
            border-right: 1px solid var(--black);
            cursor: pointer;

            &:last-of-type {
              border-right: none;
            }
          }
        `}
      >
        {tabs.length > 0 && tabs
          .map((tab, i) => (
            <div
              key={tab._key}
              css={css`
                flex: 0 0 calc(100% / ${tabs.length});
                text-align: center;
                color: ${(i === active) ?  'var(--gray-1)' : 'var(--black)'};
                border-bottom: ${(i === active) ? '1px solid transparent' : '1px solid var(--black)'};
                transition: border-bottom-color 0.6s var(--curve), color 0.6s var(--curve), background-color 0.6s var(--curve);

                @media (max-width: 900px) {
                  text-align: left;
                }

                &:hover {
                  color: var(--white);
                  background-color: var(--black);

                  span span {
                    background-color: var(--white);
                  }
                }

                span span {
                  background-color: ${(i === active) ?  'var(--gray-1)' : 'var(--black)'};
                  transition: background-color 0.6s var(--curve);
                }
              `}
              role="button"
              aria-expanded={(i === active) ? true : false}
              tabIndex="0"
              onClick={() => setActive(i)}
              onKeyPress={(e) => {
                e.persist();

                if (e.key === 'Enter') setActive(i);
              }}
            >
              <div>
                {tab.tabTitle}
                <span
                  css={css`
                    display: inline-block;
                    position: relative;
                    top: -1.36rem;
                    left: 3rem;
                    line-height: 0;
                    text-align: right;
                    cursor: pointer;

                    @media (max-width: 900px) {
                      top: -1.4rem;
                      width: 3rem;
                      left: 0;
                    }
                  `}
                >
                  <span
                    css={css`
                      position: absolute;
                      top: 9px;
                      right: 5px;
                      width: 11px;
                      height: 1px;
                      background-color: var(--black);

                      @media (max-width: 900px) {
                        top: 8px;
                        width: 9px;
                      }
                    `}
                  ></span>
                  <span
                    css={css`
                      position: absolute;
                      top: 4px;
                      right: 10px;
                      width: 1px;
                      height: 11px;
                      background-color: var(--black);
                      transform: rotate(${(i === active) ?  '90deg' : 0});
                      transition: transform 0.6s var(--curve);

                      @media (max-width: 900px) {
                        right: 9px;
                        height: 9px;
                      }
                    `}
                  ></span>
                </span>
              </div>
            </div>
          ))
        }
      </div>
      <div>
        {tabs.length > 0 && tabs
          .map((tab, i) => (
            <div
              key={i}
              css={css`
                display: ${(i === active) ?'block' : 'none'};
                margin-top: 8rem;

                @media (max-width: 900px) {
                  margin-top: 3rem;
                }
              `}
            >
              {tab._type === 'tabTextImage' &&
                <div
                  css={css`
                    display: grid;
                    grid-template-columns: repeat(12, 1fr);
                    gap: var(--gutter);
                    padding: 0 var(--margin);
                  `}
                >
                  <div
                    css={css`
                      grid-column: span 5;

                      @media (max-width: 900px) {
                        grid-column: span 12;
                        order: 2;
                      }
                    `}
                  >
                    <div
                      className="type--large"
                      css={css`
                        margin-bottom: 7rem;

                        @media (max-width: 900px) {
                          margin-bottom: 3rem;
                        }
                      `}
                    >
                      {tab.title}
                    </div>
                    <PortableText
                      css={css`
                        ul {
                          columns: 2;
                          column-gap: var(--gutter);
                          margin-top: 5rem;
                          
                          li {
                            margin-bottom: 2rem;
                          }
                        }
                      `}
                      blocks={tab._rawContent}
                    />
                  </div>
                  <div
                    css={css`
                      grid-column-start: 7;
                      grid-column-end: span 6;

                      @media (max-width: 900px) {
                        grid-column-start: 1;
                        grid-column-end: span 12;
                        order: 1;
                        margin-bottom: 2rem;
                      }
                    `}
                  >
                  {tab.image && <Image
                    {...tab.image}
                    width={990}
                    style={{
                      width: '100%',
                      border: '1px solid var(--black)',
                    }}
                  />}
                  </div>
                </div>
              }
              {tab._type === 'tabText' &&
                <div
                  css={css`
                    display: grid;
                    grid-template-columns: repeat(12, 1fr);
                    gap: var(--gutter);
                    padding: 0 var(--margin);
                  `}
                >
                  <div
                    css={css`
                      grid-column: span 4;
                    `}
                  >
                  </div>
                  <div
                    css={css`
                      grid-column: span 8;
                    `}
                  >
                    <div
                      className="type--heading-two"
                      css={css`
                        position: relative;
                        top: -2rem;
                        margin-bottom: 5rem;
                      `}
                    >
                      {tab.title}
                    </div>
                  </div>
                  <div
                    css={css`
                      grid-column: span 8;
                    `}
                  >
                    <PortableText
                      css={css`
                        columns: 2;
                        column-gap: var(--gutter);
                      `}
                      blocks={tab._rawContent}
                    />
                  </div>
                </div>
              }
            </div>
          ))
        }
      </div>
    </div>
  )
}
